export default __webpack_public_path__ + "static/media/bg11.c6c21bd8.jpg";